// ---------------------------------------------------------------------------
// Frontend entry. Bundled by build.mjs into wwwroot/dist/app.{js,css}.
// Imports self-hosted fonts + the SCSS framework, then wires up the small set
// of progressive-enhancement behaviours. Everything degrades gracefully: with
// JS disabled, tab panels stack and confirm-guards simply submit.
// ---------------------------------------------------------------------------

// Self-hosted fonts (latin subset) — see build.mjs for why these are bundled.
import "@fontsource/poppins/latin-600.css";
import "@fontsource/poppins/latin-700.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";

// The style framework.
import "./styles/app.scss";

// Behaviours.
import { initTabs } from "./scripts/tabs";
import { initConfirm } from "./scripts/confirm";
import { initClipboard } from "./scripts/clipboard";
import { initStatistics } from "./scripts/statistics";

function onReady(fn: () => void): void {
  if (document.readyState !== "loading") fn();
  else document.addEventListener("DOMContentLoaded", fn);
}

onReady(() => {
  initTabs();
  initConfirm();
  initClipboard();
  initStatistics();
});
